import { render, staticRenderFns } from "./StatusCom.vue?vue&type=template&id=6e631764&scoped=true"
import script from "./StatusCom.vue?vue&type=script&lang=js"
export * from "./StatusCom.vue?vue&type=script&lang=js"
import style0 from "./StatusCom.vue?vue&type=style&index=0&id=6e631764&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e631764",
  null
  
)

export default component.exports